export default __webpack_public_path__ + "static/media/8.bf449e09.jpg";